import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { map, Observable } from 'rxjs';
import { TransactionStatusHistoryModel } from '@shared/data-access/models/transaction-status-history.model';

@Injectable({
  providedIn: 'root',
})
export class TransactionActionStatusHistoryApiService {
  static TRANSACTION_STATUS = 'transaction/status';

  constructor(private apiService: ApiService) {}

  search(
    query: { type?: string; sourceIds?: number | number[]; [key: string]: any } = {},
    option?: IApiOption
  ): Observable<PaginationAdapter<TransactionStatusHistoryModel>> {
    return this.apiService
      .get(TransactionActionStatusHistoryApiService.TRANSACTION_STATUS, query, option)
      .pipe(map((data) => new PaginationAdapter(TransactionStatusHistoryModel, data)));
  }
}
